import dayjs, { type Dayjs } from 'dayjs'

export function getDate(maybeDate: string | Date | number | Dayjs | undefined | null) {
  if (!maybeDate) {
    return null
  }

  const dayJsDate = dayjs(maybeDate)

  if (dayJsDate.isValid()) {
    return dayJsDate.toDate()
  }

  return null
}
